import apiRequest from "../services/apiservice";

const POST = "POST",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  URLENCODED = "urlencoded",
  FORMDATA = "formdata",
  JSONDATA = "json";

export default {
  // --- AUTH ---
  login: (data) => apiRequest(POST, "/api/auth/login", data, URLENCODED),
  logout: () => apiRequest(POST, "/api/auth/logout"),
  // --- PERSONAL ---
  me: () => apiRequest(GET, "/api/users/me"),
  // --- UPLOAD IMAGE ---
  upload_image: (data) => apiRequest(POST, "/api/uploadImage", data, FORMDATA),
  // --- LOTTERY ---
  get_lottery_list: (data) => apiRequest(GET, "/api/lotteries", data),
  get_lottery_by_id: (id) => apiRequest(GET, `/api/lotteries/${id}`),
  give_lottery: (id, data) =>
    apiRequest(POST, `/api/lotteries/${id}/give`, data, JSONDATA),
  // Award
  award_list: (id) => apiRequest(GET, `api/lotteries/${id}/draws`),
  create_award: (data) => apiRequest(POST, "/api/lotteries/draw", data),
  delete_award: (id) => apiRequest(DELETE, `/api/lotteries/draw/${id}`),
  // Create & update
  create_lottery: () => apiRequest(POST, "/api/lotteries"),
  update_lottery: (id, data) =>
    apiRequest(PUT, `/api/lotteries/${id}`, data, JSONDATA),
  // Visibility & Status
  update_lottery_state: (id, data) =>
    apiRequest(PATCH, `/api/lotteries/${id}/state`, data, JSONDATA),
  // Numbers
  generate_numbers: (id) => apiRequest(POST, `/api/lotteries/${id}/numbers`),
  get_lottery_numbers: (id, params) =>
    apiRequest(GET, `/api/lotteries/${id}/numbers`, params, JSONDATA),
  // Draw winning nums
  draw_winning_number: (id, data) =>
    apiRequest(PATCH, `/api/lotteries/${id}/draws`, data, JSONDATA),
  reset_draw_number: (drawId) =>
    apiRequest(PATCH, `/api/lotteries/${drawId}/reset`, {}, JSONDATA),
  update_draw_status: (id, is_drawing) =>
    apiRequest(PATCH, `/api/lotteries/${id}/status`, { is_drawing }, JSONDATA),
  // Complete
  update_status_to_completed: (id) =>
    apiRequest(PATCH, `/api/lotteries/${id}/complete`, {}, JSONDATA),
  // PREVIEW SORT
  update_preview_sort: (data) =>
    apiRequest(PATCH, `/api/lotteries/preview-sort`, data, JSONDATA),
  // --- SMS ---
  get_sms_list: (params) => apiRequest(GET, "/api/sms", params),
  get_mass_sms_list: (params) =>
    apiRequest(GET, "/api/sms/mass-messages", params),
  send_sms: (data) => apiRequest(POST, "/api/sms", data, JSONDATA),
  cancel_sms: (id, data) =>
    apiRequest(POST, `/api/sms/${id}/cancel-sms`, data, JSONDATA),
  // --- BANK ---
  create_bank: (data) => apiRequest(POST, "/api/bank", data, JSONDATA),
  get_bank_list: () => apiRequest(GET, "/api/bank"),
  delete_bank: (data) => apiRequest(DELETE, "/api/bank", data, JSONDATA),
  get_all_bank_statements: (params) =>
    apiRequest(GET, "/api/bank/statements", params),
  // --- USERS ---
  create_user: (data) => apiRequest(POST, "/api/users/create", data, JSONDATA),
  get_user_list: () => apiRequest(GET, "/api/users"),
  update_user: (id, data) =>
    apiRequest(PATCH, `/api/users/${id}`, data, JSONDATA),
  delete_user: (id) => apiRequest(DELETE, `/api/users/${id}`),
  change_password: (id, data) =>
    apiRequest(POST, `/api/users/${id}/password`, data, JSONDATA),
  get_operator_list: () => apiRequest(GET, "/api/users/operators"),
  // --- TICKET ---
  get_ticket_list: (params) =>
    apiRequest(GET, "/api/tickets", params, JSONDATA),
  // --- COMPLAINT ---
  get_complaint_list: (params) =>
    apiRequest(GET, "/api/complaints", params, JSONDATA),
  get_complaint_detail: (id) => apiRequest(GET, `/api/complaints/${id}`),
  create_complaint: (data) =>
    apiRequest(POST, "/api/complaints/create", data, JSONDATA),
  reject_complaint: (id, data) =>
    apiRequest(PATCH, `/api/complaints/${id}/reject`, data, JSONDATA),
  resolve_complaint: (id, data) =>
    apiRequest(PATCH, `/api/complaints/${id}/resolve`, data, JSONDATA),
  get_complaint_reference: () => apiRequest(GET, "/api/complaints/reference"),
  // --- NEWS ---
  get_news_list: () => apiRequest(GET, "/api/news"),
  get_news_detail: (id) => apiRequest(GET, `/api/news/${id}`),
  create_draft_news: () => apiRequest(POST, "/api/news"),
  update_news: (data) => apiRequest(PUT, `/api/news`, data, JSONDATA),
  update_news_status: (id, data) =>
    apiRequest(PATCH, `/api/news/${id}/status`, data, JSONDATA),
  // --- DASHBOARD ---
  get_stats: () => apiRequest(GET, "/api/dashboard/stats"),
  // --- IMAGE ---
  get_image_list: () => apiRequest(GET, "/api/images"),
  // --- CALL CENTER ---
  get_call_list: (params) => apiRequest(GET, "/api/call-center", params),
  create_call_list: (data) =>
    apiRequest(POST, "/api/call-center", data, JSONDATA),
  get_call_list_stats: (id) => apiRequest(GET, `/api/call-center/${id}/stats`),
  call_center_toggle_pin: (data) =>
    apiRequest(POST, "/api/call-center/target/pin", data, JSONDATA),

  // OPERATOR
  // get_current_target: (listId, agentId) =>
  //   apiRequest(GET, "/api/call-center/current", {
  //     params: { list_id: listId, agent_id: agentId },
  //   }),

  // // submit attempt
  // create_attempt: (listId, targetId, payload) =>
  //   apiRequest(POST, "/api/call-center/attempt", {
  //     list_id: listId,
  //     target_id: targetId,
  //     ...payload, // { agent_id, outcome, notes, qualify }
  //   }),

  // // claim next
  // claim_next_target: (listId, agentId) =>
  //   apiRequest(POST, "/api/call-center/claim-next", {
  //     list_id: listId,
  //     agent_id: agentId,
  //   }),

  // mutate
  get_current_or_claim: (data) =>
    apiRequest(POST, "/api/call-center/current", data, JSONDATA),

  claim_next_target: (data) =>
    apiRequest(POST, "/api/call-center/claim-next", data, JSONDATA),

  create_attempt: (data) =>
    apiRequest(POST, "/api/call-center/attempt", data, JSONDATA),

  call_center_sms: (data) =>
    apiRequest(POST, "/api/call-center/send", data, JSONDATA),

  // export_excel_data: (data) =>
  //   apiRequest(GET, "/api/call-center/export", data, JSONDATA),

  export_excel_data: (params) =>
    apiRequest(GET, "/api/call-center/export", params, undefined, {
      responseType: "blob",
    }),
  // --- REWARD ---
  get_campaign_list: (params) =>
    apiRequest(GET, "/api/rewards/campaigns", params),
  get_grants_by_campaign: (id, params) =>
    apiRequest(GET, `/api/rewards/campaigns/${id}/grants`, params),
  create_reward_campaign: (data) =>
    apiRequest(POST, "/api/rewards/campaigns", data, JSONDATA),
  update_reward_campaign: (id, data) =>
    apiRequest(PATCH, `/api/rewards/campaigns/${id}`, data, JSONDATA),
  // --- REPORT ---
  lottery_progress: (params) =>
    apiRequest(GET, "/api/reports/lottery-progress", params),
  report_lottery: () => apiRequest(GET, "/api/reports/lottery"),
};
